export const PER_PAGE = 30;
export const DEFAULT_AVATAR_URL = '/home/img/default_avatar.png';
export const ACCESS_TOKEN_NAME = 'ss_cloud_access_token';
export const API_URL = process.env.NODE_ENV === 'production' ? 'https://api.sscms.com/v7/home' : 'http://localhost/v7/home';
export const { BASE_URL } = process.env;
export const HOST_URL = 'https://sscms.com';
export const HOST_URL_DL = 'https://dl.sscms.com';
export const HOST_URL_STORAGE = 'https://storage.sscms.com';
export const HOST_DOMAIN_MAINLAND = 'sscms.net';
export const HOST_DOMAIN_HONGKONG = 'get3w.com';

export const HOST_FEATURES = [
  {
    functions: 'SSCMS 版本自动升级',
    starter: true,
    standard: true,
    professional: true,
  },
  {
    functions: '网站挂马清理',
    starter: true,
    standard: true,
    professional: true,
  },
  {
    functions: '安全漏洞修复',
    starter: true,
    standard: true,
    professional: true,
  },
  {
    functions: '系统BUG修复',
    starter: true,
    standard: true,
    professional: true,
  },
  {
    functions: '收费模板',
    starter: '6折优惠',
    standard: '5折优惠',
    professional: '4折优惠',
  },
  {
    functions: '收费插件',
    starter: '6折优惠',
    standard: '5折优惠',
    professional: '4折优惠',
  },
  {
    functions: '系统安全加固',
    starter: true,
    standard: true,
    professional: true,
  },
  {
    functions: '故障应急响应',
    starter: '5×8小时',
    standard: '7×8小时',
    professional: '7×24小时',
  },
  {
    functions: '工单技术支持',
    starter: '5×8小时',
    standard: '7×8小时',
    professional: '7×24小时',
  },
  {
    functions: '自定义域名',
    starter: true,
    standard: true,
    professional: true,
  },
  {
    functions: '启用 HTTPS',
    starter: true,
    standard: true,
    professional: true,
  },
  {
    functions: '前后台分离',
    starter: true,
    standard: true,
    professional: true,
  },
  {
    functions: '支持站点数量',
    starter: '2个',
    standard: '10个',
    professional: '不限数量',
  },
  {
    functions: '赠送SSL加密证书',
    starter: '2个',
    standard: '10个',
    professional: '不限数量',
  },
  {
    functions: '磁盘空间（含数据库）',
    starter: '2 GB',
    standard: '10 GB',
    professional: '50 GB',
  },
  {
    functions: '手动备份',
    starter: '保留最近1次',
    standard: '保留最近3次',
    professional: '保留最近5次',
  },
  {
    functions: '自动备份',
    starter: '每周1次',
    standard: '每周3次',
    professional: '每日备份',
  },
  {
    functions: 'SFTP',
    starter: false,
    standard: true,
    professional: true,
  },
  {
    functions: '高性能MYSQL集群数据库',
    starter: false,
    standard: false,
    professional: true,
  },
  {
    functions: '高性能服务器',
    starter: false,
    standard: false,
    professional: true,
  },
  {
    functions: '',
    starter: false,
    standard: false,
    professional: false,
  },
];
